import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom'
import { Provider } from 'react-redux';
import { sessionService } from 'redux-react-session';

import { appActions } from './core/app';
import { api } from './core/api';
import history from './core/history';
import configureStore from './core/store';

import App from './App';

import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById('root');
const store = configureStore();

// Init the session service
sessionService.initSessionService(store);

store.dispatch(appActions.initApp({}));

const validateSession = async (session) => {
  window.sessionId = session.token || null;
  return await api.fetchProvider(session.user).then(response => response.error.code === 0 && response.data.sessionId === session.token )
}

const options = { refreshOnCheckAuth: true, redirectPath: '/home', driver: 'COOKIES', validateSession };

sessionService.initSessionService(store, options)
  .then(() => console.log('Redux React Session is ready and a session was refreshed from your storage'))
  .catch(() => console.log('Redux React Session is ready and there is no session in your storage'));

function render(Component) {
  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
          <Component/>
      </Router>
    </Provider>,
    rootElement
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
/*
if (module.hot) {
  module.hot.accept('./App', () => {
    render(require('./App').default);
  });
}

*/

render(App);
